/* eslint-disable react-refresh/only-export-components --
 * Co-locates the filter type contract with the toolbar component.
 * Editing this file forces a full reload during dev — acceptable trade-off.
 */
import type { ProductType } from '@/types';

import styles from './ShopFilters.module.css';

export type SortKey = 'DROP' | 'PRICE ASC' | 'PRICE DESC' | 'STATE';
export type TypeFilter = ProductType | 'ALL';

export const SORTS: readonly SortKey[] = ['DROP', 'PRICE ASC', 'PRICE DESC', 'STATE'];

export function isSortKey(v: string): v is SortKey {
  return (SORTS as readonly string[]).includes(v);
}

interface ShopFiltersProps {
  types: readonly TypeFilter[];
  type: TypeFilter;
  onTypeChange: (next: TypeFilter) => void;
  sort: SortKey;
  onSortChange: (next: SortKey) => void;
  showArchive: boolean;
  onToggleArchive: () => void;
}

export default function ShopFilters({
  types,
  type,
  onTypeChange,
  sort,
  onSortChange,
  showArchive,
  onToggleArchive,
}: ShopFiltersProps) {
  return (
    <div className={styles.root}>
      <div className={styles.left}>
        {types.map((t) => (
          <button
            key={t}
            type="button"
            className={'filter-btn' + (type === t ? ' active' : '')}
            onClick={() => onTypeChange(t)}
          >
            {t}
          </button>
        ))}
      </div>
      <div className={styles.right}>
        <span>SORT</span>
        <select
          className={styles.select}
          value={sort}
          onChange={(e) => {
            if (isSortKey(e.target.value)) onSortChange(e.target.value);
          }}
        >
          {SORTS.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        <button
          type="button"
          className={'filter-btn' + (showArchive ? ' active' : '')}
          onClick={onToggleArchive}
        >
          {showArchive ? 'LIVE' : 'ARCHIVE'}
        </button>
      </div>
    </div>
  );
}
